import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import { useScreenshotTranslation } from "../../../lib/screenshotI18n";
import {
    getJigsawDifficultyDisplayInfo,
    resolveJigsawTemplateTileSize,
} from "../lib/jigsawScreenshotUtils";
import { puzzleTitleBarSx, promoSubtitleSx } from "../styles/mainStyles";

/**
 * Puzzle name under the board — difficulty chip (play-page colors) + title.
 */
export default function ScreenshotPuzzleTitleBar({ title, template, grid = 0, dark = false }) {
    const { t } = useScreenshotTranslation();
    const tileSize = grid > 0 ? grid : resolveJigsawTemplateTileSize(template);
    const levelInfo =
        tileSize > 0
            ? getJigsawDifficultyDisplayInfo(
                  tileSize,
                  template?.difficultyLevel ?? template?.difficulty_level,
              )
            : null;

    if (!title && !levelInfo) return null;

    const difficultyLabel = levelInfo
        ? t(`puzzle.card.difficulty-${levelInfo.level.toLowerCase()}`)
        : null;

    return (
        <Box
            sx={{
                ...puzzleTitleBarSx,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
                flexWrap: "wrap",
            }}
        >
            {levelInfo ? (
                <Chip
                    label={difficultyLabel}
                    color={levelInfo.chipColor}
                    variant="filled"
                    size="small"
                    sx={{ flexShrink: 0, fontWeight: 600 }}
                />
            ) : null}
            {title ? (
                <Typography
                    component="p"
                    sx={{
                        ...promoSubtitleSx,
                        m: 0,
                        ...(dark ? { color: "#ecfdf5" } : null),
                    }}
                >
                    {title}
                </Typography>
            ) : null}
        </Box>
    );
}
